module.exports = __webpack_public_path__ + "img/symbol_9.a34af920.png";